import { render, staticRenderFns } from "./CommentView.vue?vue&type=template&id=1c44d5f4&scoped=true&"
import script from "./CommentView.vue?vue&type=script&lang=js&"
export * from "./CommentView.vue?vue&type=script&lang=js&"
import style0 from "./CommentView.vue?vue&type=style&index=0&id=1c44d5f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c44d5f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c44d5f4')) {
      api.createRecord('1c44d5f4', component.options)
    } else {
      api.reload('1c44d5f4', component.options)
    }
    module.hot.accept("./CommentView.vue?vue&type=template&id=1c44d5f4&scoped=true&", function () {
      api.rerender('1c44d5f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/statistics/user-join/view/CommentView.vue"
export default component.exports